import * as Ajax from '../ajax/Ajax';
import moment from "moment-timezone";
/**
 * 会議名(Room name)一覧取得
 *
 * @param fn ファンクション
 */

export function GetSessionNameList(fn) {
  Ajax.Post("SessionHistoryApi/GetSessionNameList", {}, Ajax.ModelResult(fn));
}
/**
 * 会議開催履歴一覧を指定条件で取得します。
 *
 * @param sessionId 検索会議ID
 * @param startDate 検索開始日時
 * @param endDate 検索終了日時
 * @param searchWord 検索ワード
 * @param isAsync 非同期オプション
 * @param fn ファンクション
 */

export function Query(sessionId, startDate, endDate, searchWord, isAsync, fn) {
  if (isAsync) {
    Ajax.Post("SessionHistoryApi/QueryAsync", {
      sessionId: sessionId,
      startDate: startDate == null ? null : moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
      endDate: endDate == null ? null : moment(endDate).format("YYYY-MM-DDTHH:mm:ss"),
      searchWord: searchWord
    }, Ajax.ModelResult(fn));
  } else {
    Ajax.Post("SessionHistoryApi/Query", {
      sessionId: sessionId,
      startDate: startDate == null ? null : moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
      endDate: endDate == null ? null : moment(endDate).format("YYYY-MM-DDTHH:mm:ss"),
      searchWord: searchWord
    }, Ajax.ModelResult(fn));
  }
}
/**
 * キャプチャを取得します。
 *
 * @param sessionId 会議ID
 * @param captureImageFileName キャプチャファイル名
 * @param i 行インデックス
 * @param j 列インデックス
 * @param fn ファンクション
 */

export function GetCapture(sessionId, captureImageFileName, i, j, fn) {
  var data = new FormData();
  data.append("sessionId", sessionId.toString());
  data.append("captureImageFileName", captureImageFileName);
  Ajax.Image("SessionHistoryApi/GetFileImage", data, i, j, fn);
}
/**
 * キャプチャを削除します。
 *
 * @param sessionId 会議ID
 * @param sessionHistoryId 会議履歴ID
 * @param fn ファンクション
 */

export function DeleteCapture(sessionId, sessionHistoryId, fn) {
  Ajax.Post("SessionHistoryApi/DeleteCapture", {
    sessionId: sessionId,
    sessionHistoryId: sessionHistoryId
  }, Ajax.ModelResult(fn));
}
/**
 * キャプチャをシーンのサムネイルとして登録します。
 *
 * @param sessionId 会議ID
 * @param sessionHistoryId 会議履歴ID
 * @param fn ファンクション
 */

export function SetSceneThumbnail(sessionId, sessionHistoryId, fn) {
  Ajax.Post("SessionHistoryApi/SetSceneThumbnail", {
    sessionId: sessionId,
    sessionHistoryId: sessionHistoryId
  }, Ajax.ModelResult(fn));
}
/**
 * キャプチャをシーンのサムネイルから解除します。
 *
 * @param sessionId 会議ID
 * @param sessionHistoryId 会議履歴ID
 * @param fn ファンクション
 */

export function ClearSceneThumbnail(sessionId, sessionHistoryId, fn) {
  Ajax.Post("SessionHistoryApi/ClearSceneThumbnail", {
    sessionId: sessionId,
    sessionHistoryId: sessionHistoryId
  }, Ajax.ModelResult(fn));
}
/**
 * 会議メモ情報を編集します。
 *
 * @param sessionId 会議ID
 * @param entryDateTime 登録日時
 * @param memo メモ
 * @param fn ファンクション
 */

export function EditMemo(sessionId, entryDateTime, memo, fn) {
  Ajax.Post("SessionHistoryApi/EditMemo", {
    sessionId: sessionId,
    entryDateTime: entryDateTime.toString(),
    memo: memo
  }, Ajax.ModelResult(fn));
}